<div
  *ngIf="{
    isCodeSent: codeSentId$ | async,
    showSuccess: showSuccess$ | async,
  } as conditions"
  class="ui-modal"
>
  <div class="header flex-row space-between-center">
    <span>{{ 'SUAS.ACCOUNT.DETAILS.TITLE' | translate }}</span>
    <span class="ui-icon-close c-p" matDialogClose></span>
  </div>
  <div class="body gap-16">
    <ng-container *ngIf="!conditions.showSuccess">
      <div class="flex-col gap-8">
        <span>{{ 'SUAS.ACCOUNT.DETAILS.PHONE' | translate }}</span>
        <ui-phone-input
          class="w-100"
          inputClass="ui-phone-input-40"
          [formControl]="phoneControl"
        >
        </ui-phone-input>
      </div>
      <ng-container *ngIf="conditions.isCodeSent">
        <div class="flex-col gap-8">
          <label>{{ 'SUAS.ACCOUNT.DETAILS.CONFIRMATION_CODE' | translate }}</label>
          <input
            class="ui-input ui-input-40"
            type="email"
            [formControl]="confirmationCodeControl"
          />
          <ng-container *ngrxLet="resendTimer$; let timer">
            <a
              class="link"
              [class.c-p]="!timer"
              (click)="timer ? null : sendCode()"
            >
              {{ 'SUAS.ACCOUNT.DETAILS.RESEND_MSG' | translate }}
              <ng-container *ngIf="timer">
                (00:{{ timer < 10 ? '0' : null }}{{ timer }})
              </ng-container>
            </a>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div *ngIf="!conditions.showSuccess" class="footer flex-row end-center gap-8">
    <ui-button
      [text]="'SUAS.COMMON.CANCEL' | translate"
      type="default"
      (clickAction)="close()"
    ></ui-button>
    <ui-button
      *ngIf="!conditions.isCodeSent"
      [loading]="selectIsSaving$ | ngrxPush"
      [disabled]="phoneControl.invalid"
      [text]="'SUAS.ACCOUNT.DETAILS.GET_CODE' | translate"
      (clickAction)="sendCode()"
    ></ui-button>
    <ui-button
      *ngIf="conditions.isCodeSent"
      [loading]="selectIsSaving$ | ngrxPush"
      [disabled]="confirmationCodeControl.invalid"
      [text]="'SUAS.COMMON.SEND' | translate"
      (clickAction)="confirmCode()"
    ></ui-button>
  </div>
</div>
